module.exports = __webpack_public_path__ + "img/arrow.08f6a0c2.png";